import * as r from 'ramda';
import { createSelector } from 'reselect';

const getArtsBase = r.prop('arts');

const mapArtsetProduct = ({
  Configuration: {
    Id: id,
    SetName: setName,
    Name: name,
    Tags: tags,
    ImageUrl: image,
    ThumbnailImageUrl: thumbnailImage,
    NaturalWidth: naturalWidth,
    NaturalHeight: naturalHeight,
    ThumbnailWidth: thumbnailWidth,
    ThumbnailHeight: thumbnailHeight,
    CropOrientation: cropOrientation = 'same',
    ZoomScale: scale = 1,
    TranslateX: translateX = 0,
    TranslateY: translateY = 0,
  }
}) => ({
  id,
  setName,
  name,
  tags,
  image,
  thumbnailImage,
  naturalWidth,
  naturalHeight,
  thumbnailWidth,
  thumbnailHeight,
  cropOrientation,
  scale,
  translateX,
  translateY,
});

export const getArtProducts = createSelector(
  r.pipe(getArtsBase, r.prop('artProducts')),
  r.map(mapArtsetProduct),
);
